import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import '../styles/order.css';

const removeVietnameseTones = (str) => {
    if (!str) return '';
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    // Remove combining diacritical marks
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
    str = str.replace(/\u02C6|\u0306|\u031B/g, "");
    // Remove non-alphanumeric characters
    str = str.replace(/[^a-zA-Z0-9]/g, "");
    return str;
};

const Order = () => {
    const { cartItems, updateQuantity, removeFromCart, cartTotal } = useCart();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        senderName: '',
        senderPhone: '',
        receiverName: '',
        receiverPhone: '',
        deliveryAddress: '',
        deliveryWard: '',
        deliveryDistrict: '',
        deliveryProvince: '',
        deliveryDate: new Date().toISOString().split('T')[0],
        deliveryTime: 'Giao ngay',
        cardMessage: '',
        photoBeforeDelivery: false,
        anonymous: false,
        vatInvoice: false,
        notes: ''
    });

    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: null }));
        }
    };

    const formatPrice = (price) => {
        if (price == null || price === '' || Number(price) === 0) return 'Liên hệ';
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(price);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.senderName.trim()) newErrors.senderName = 'Vui lòng nhập tên người đặt';
        if (!formData.senderPhone.trim()) {
            newErrors.senderPhone = 'Vui lòng nhập số điện thoại người đặt';
        } else if (!/^[0-9]{9,11}$/.test(formData.senderPhone.trim())) {
            newErrors.senderPhone = 'Số điện thoại không hợp lệ';
        }

        if (!formData.receiverName.trim()) newErrors.receiverName = 'Vui lòng nhập tên người nhận';
        if (!formData.receiverPhone.trim()) {
            newErrors.receiverPhone = 'Vui lòng nhập số điện thoại người nhận';
        } else if (!/^[0-9]{9,11}$/.test(formData.receiverPhone.trim())) {
            newErrors.receiverPhone = 'Số điện thoại không hợp lệ';
        }

        if (!formData.deliveryAddress.trim()) newErrors.deliveryAddress = 'Vui lòng nhập địa chỉ giao hoa';
        if (!formData.deliveryWard.trim()) newErrors.deliveryWard = 'Vui lòng nhập Phường/Xã';
        if (!formData.deliveryDistrict.trim()) newErrors.deliveryDistrict = 'Vui lòng nhập Quận/Huyện';
        if (!formData.deliveryProvince.trim()) newErrors.deliveryProvince = 'Vui lòng nhập Tỉnh/Thành phố';
        if (!formData.deliveryDate) newErrors.deliveryDate = 'Vui lòng chọn ngày giao hoa';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (cartItems.length === 0) {
            alert('Giỏ hàng trống! Vui lòng thêm sản phẩm.');
            return;
        }

        if (!validateForm()) {
            const firstErrorEl = document.querySelector('.error-message');
            if (firstErrorEl) {
                firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }

        // Generate transfer content: Name + Phone without Vietnamese tones
        const nameClean = removeVietnameseTones(formData.senderName.trim());
        const phoneClean = formData.senderPhone.trim();
        const transferContent = `${nameClean}${phoneClean}`;

        const finalTotal = formData.vatInvoice ? Math.round(cartTotal * 1.08) : cartTotal;

        // Navigate to payment with form data & cart totals
        navigate('/thanh-toan', {
            state: {
                order: {
                    ...formData,
                    transferContent,
                    items: cartItems,
                    total: finalTotal
                }
            }
        });
    };

    if (cartItems.length === 0) {
        return (
            <div className="order-empty-container">
                <div className="order-empty-box">
                    <i className="fas fa-shopping-bag empty-icon"></i>
                    <h2>Giỏ hàng của bạn đang trống</h2>
                    <p>Hãy chọn những bó hoa tươi đẹp nhất của Hoa Tháng Năm để gửi gắm tình yêu thương nhé!</p>
                    <Link to="/products" className="order-empty-btn">
                        <i className="fas fa-arrow-left"></i> Xem sản phẩm hoa
                    </Link>
                </div>
            </div>
        );
    }

    const todayStr = new Date().toISOString().split('T')[0];
    const finalTotal = formData.vatInvoice ? Math.round(cartTotal * 1.08) : cartTotal;

    return (
        <div className="order-page-wrapper">
            <div className="order-container">
                <div className="order-breadcrumbs">
                    <Link to="/">Trang chủ</Link>
                    <i className="fas fa-chevron-right"></i>
                    <span>Đặt hàng & Giỏ hàng</span>
                </div>

                <h1 className="order-page-title">Thông tin đặt hoa</h1>

                <form onSubmit={handleSubmit} className="order-grid">
                    {/* Left Column: Form Info */}
                    <div className="order-form-column">
                        
                        {/* 1. Customer Info */}
                        <div className="order-section-card">
                            <h2 className="section-title">
                                <span className="section-number">1</span>
                                Thông tin người đặt hoa
                            </h2>
                            <div className="form-grid">
                                <div className="form-group">
                                    <label htmlFor="senderName">Tên người đặt *</label>
                                    <input 
                                        type="text" 
                                        id="senderName" 
                                        name="senderName"
                                        placeholder="Nhập tên của bạn"
                                        value={formData.senderName}
                                        onChange={handleInputChange}
                                        className={errors.senderName ? 'input-error' : ''}
                                    />
                                    {errors.senderName && <span className="error-message">{errors.senderName}</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="senderPhone">Số điện thoại *</label>
                                    <input 
                                        type="tel" 
                                        id="senderPhone" 
                                        name="senderPhone"
                                        placeholder=""
                                        value={formData.senderPhone}
                                        onChange={handleInputChange}
                                        className={errors.senderPhone ? 'input-error' : ''}
                                    />
                                    {errors.senderPhone && <span className="error-message">{errors.senderPhone}</span>}
                                </div>
                            </div>
                        </div>

                        {/* 2. Recipient Info */}
                        <div className="order-section-card">
                            <h2 className="section-title">
                                <span className="section-number">2</span>
                                Thông tin người nhận hoa
                            </h2>
                            <div className="form-grid">
                                <div className="form-group">
                                    <label htmlFor="receiverName">Tên người nhận *</label>
                                    <input 
                                        type="text" 
                                        id="receiverName" 
                                        name="receiverName"
                                        placeholder="Nhập tên người nhận hoa"
                                        value={formData.receiverName}
                                        onChange={handleInputChange}
                                        className={errors.receiverName ? 'input-error' : ''}
                                    />
                                    {errors.receiverName && <span className="error-message">{errors.receiverName}</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="receiverPhone">Số điện thoại người nhận *</label>
                                    <input 
                                        type="tel" 
                                        id="receiverPhone" 
                                        name="receiverPhone"
                                        placeholder=""
                                        value={formData.receiverPhone}
                                        onChange={handleInputChange}
                                        className={errors.receiverPhone ? 'input-error' : ''}
                                    />
                                    {errors.receiverPhone && <span className="error-message">{errors.receiverPhone}</span>}
                                </div>
                            </div>

                            <div className="form-group full-width" style={{ marginTop: '1rem' }}>
                                <label htmlFor="deliveryAddress">Địa chỉ giao hoa chi tiết (Số nhà, Tên đường) *</label>
                                <input 
                                    type="text" 
                                    id="deliveryAddress" 
                                    name="deliveryAddress"
                                    placeholder=""
                                    value={formData.deliveryAddress}
                                    onChange={handleInputChange}
                                    className={errors.deliveryAddress ? 'input-error' : ''}
                                />
                                {errors.deliveryAddress && <span className="error-message">{errors.deliveryAddress}</span>}
                            </div>

                            <div className="form-grid" style={{ marginTop: '1rem' }}>
                                <div className="form-group">
                                    <label htmlFor="deliveryWard">Phường/Xã *</label>
                                    <input 
                                        type="text" 
                                        id="deliveryWard" 
                                        name="deliveryWard"
                                        placeholder=""
                                        value={formData.deliveryWard}
                                        onChange={handleInputChange}
                                        className={errors.deliveryWard ? 'input-error' : ''}
                                    />
                                    {errors.deliveryWard && <span className="error-message">{errors.deliveryWard}</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="deliveryDistrict">Quận/Huyện *</label>
                                    <input 
                                        type="text" 
                                        id="deliveryDistrict" 
                                        name="deliveryDistrict"
                                        placeholder=""
                                        value={formData.deliveryDistrict}
                                        onChange={handleInputChange}
                                        className={errors.deliveryDistrict ? 'input-error' : ''}
                                    />
                                    {errors.deliveryDistrict && <span className="error-message">{errors.deliveryDistrict}</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="deliveryProvince">Tỉnh/Thành phố *</label>
                                    <input 
                                        type="text" 
                                        id="deliveryProvince" 
                                        name="deliveryProvince"
                                        placeholder=""
                                        value={formData.deliveryProvince}
                                        onChange={handleInputChange}
                                        className={errors.deliveryProvince ? 'input-error' : ''}
                                    />
                                    {errors.deliveryProvince && <span className="error-message">{errors.deliveryProvince}</span>}
                                </div>
                            </div>

                            <div className="form-grid" style={{ marginTop: '1rem' }}>
                                <div className="form-group">
                                    <label htmlFor="deliveryDate">Ngày giao hoa *</label>
                                    <input 
                                        type="date" 
                                        id="deliveryDate" 
                                        name="deliveryDate"
                                        min={todayStr}
                                        value={formData.deliveryDate}
                                        onChange={handleInputChange}
                                        className={errors.deliveryDate ? 'input-error' : ''}
                                    />
                                    {errors.deliveryDate && <span className="error-message">{errors.deliveryDate}</span>}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="deliveryTime">Giờ giao hoa mong muốn</label>
                                    <select 
                                        id="deliveryTime" 
                                        name="deliveryTime"
                                        value={formData.deliveryTime}
                                        onChange={handleInputChange}
                                    >
                                        <option value="Giao ngay">Giao ngay càng sớm càng tốt</option>
                                        <option value="7h - 9h">7h00 - 9h00</option>
                                        <option value="9h - 11h">9h00 - 11h00</option>
                                        <option value="11h - 13h">11h00 - 13h00</option>
                                        <option value="13h - 15h">13h00 - 15h00</option>
                                        <option value="15h - 17h">15h00 - 17h00</option>
                                        <option value="17h - 19h">17h00 - 19h00</option>
                                        <option value="19h - 21h">19h00 - 21h00</option>
                                        <option value="Giờ cụ thể (Ghi chú)">Giờ cụ thể (Ghi rõ ở Ghi chú)</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* 3. Card/Banner & Notes */}
                        <div className="order-section-card">
                            <h2 className="section-title">
                                <span className="section-number">3</span>
                                Thiệp/banner & yêu cầu riêng
                            </h2>
                            <div className="form-group full-width">
                                <label htmlFor="cardMessage">Nội dung ghi trên thiệp/banner</label>
                                <textarea 
                                    id="cardMessage" 
                                    name="cardMessage"
                                    rows="3"
                                    placeholder="Ví dụ: Chúc mừng sinh nhật mẹ yêu! / Chúc khai trương hồng phát! / Kính viếng, Thành kính phân ưu..."
                                    value={formData.cardMessage}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <div className="form-group full-width" style={{ marginTop: '1rem' }}>
                                <label>Yêu cầu thêm dành cho shop</label>
                                <div className="checkbox-group">
                                    <label className="checkbox-item">
                                        <input 
                                            type="checkbox" 
                                            name="photoBeforeDelivery" 
                                            checked={formData.photoBeforeDelivery}
                                            onChange={handleInputChange}
                                        />
                                        <span className="checkbox-text">Gửi ảnh hoa trước khi giao hàng</span>
                                    </label>
                                    <label className="checkbox-item">
                                        <input 
                                            type="checkbox" 
                                            name="anonymous" 
                                            checked={formData.anonymous}
                                            onChange={handleInputChange}
                                        />
                                        <span className="checkbox-text">Giao hoa ẩn danh (không lộ danh tính người tặng)</span>
                                    </label>
                                    <label className="checkbox-item">
                                        <input 
                                            type="checkbox" 
                                            name="vatInvoice" 
                                            checked={formData.vatInvoice}
                                            onChange={handleInputChange}
                                        />
                                        <span className="checkbox-text">Yêu cầu xuất hoá đơn đỏ VAT (liên hệ chi tiết sau)</span>
                                    </label>
                                </div>
                            </div>

                            <div className="form-group full-width" style={{ marginTop: '1.2rem' }}>
                                <label htmlFor="notes">Ghi chú khác</label>
                                <textarea 
                                    id="notes" 
                                    name="notes"
                                    rows="2"
                                    placeholder="Ghi chú thêm đường đi, đặc điểm địa chỉ, giờ cụ thể..."
                                    value={formData.notes}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>
                        </div>

                    </div>

                    {/* Right Column: Cart items and submit */}
                    <div className="order-cart-column">
                        <div className="cart-sticky-box">
                            <h3 className="cart-box-title">Đơn hàng của bạn</h3>

                            <div className="cart-items-list">
                                {cartItems.map((item) => (
                                    <div key={item.id} className="cart-item-card">
                                        <div className="cart-item-img">
                                            <img src={item.image} alt={item.name} />
                                        </div>
                                        <div className="cart-item-info">
                                            <h4>{item.name}</h4>
                                            <div className="cart-item-price">{formatPrice(item.price)}</div>
                                            
                                            <div className="cart-item-controls">
                                                <div className="cart-item-qty">
                                                    <button 
                                                        type="button" 
                                                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                                        className="qty-btn"
                                                    >
                                                        <i className="fas fa-minus"></i>
                                                    </button>
                                                    <span className="qty-value">{item.quantity}</span>
                                                    <button 
                                                        type="button" 
                                                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                                        className="qty-btn"
                                                    >
                                                        <i className="fas fa-plus"></i>
                                                    </button>
                                                </div>

                                                <button 
                                                    type="button" 
                                                    onClick={() => removeFromCart(item.id)}
                                                    className="cart-item-delete"
                                                    title="Xoá khỏi giỏ"
                                                >
                                                    <i className="far fa-trash-alt"></i> Xoá
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="cart-totals-box">
                                <div className="total-row">
                                    <span>Tạm tính</span>
                                    <span>{formatPrice(cartTotal)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Phí vận chuyển</span>
                                    <span className="free-shipping">Miễn phí giao hàng</span>
                                </div>
                                {formData.vatInvoice && (
                                    <div className="total-row">
                                        <span>Thuế VAT (8%)</span>
                                        <span>{formatPrice(Math.round(cartTotal * 0.08))}</span>
                                    </div>
                                )}
                                <div className="total-divider"></div>
                                <div className="total-row total-row-final">
                                    <span>Tổng cộng</span>
                                    <span className="final-price">{formatPrice(finalTotal)}</span>
                                </div>
                            </div>

                            <button type="submit" className="order-submit-btn">
                                <i className="fas fa-check-circle"></i> Đặt hoa ngay
                            </button>
                            
                            <p className="order-note-hint">
                                * Sau khi bấm <strong>Đặt hoa ngay</strong>, bạn sẽ được hướng dẫn chuyển khoản thanh toán qua mã QR hoặc sao chép thông tin tài khoản.
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Order;
